import {_} from "backboneAdapter";

import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import PaginatedCollection from 'js/models/messages.paginated.collection';
import MessageRowView from 'js/views/message.row.view';
import PaginatedView from 'js/views/pagination.view';
import i18n from 'l10n';
import ContentUsageCollection from 'js/models/content.usage.paginated.collection';
import PreviewTemplate from 'js/templates/content.preview.hbs';
import {debounce,el, tagName, on} from "../adapters/backbone-decorators";

require('interfaceAdapter');

@el("#messages-container")
@tagName('span')
class MessagesView extends GenericView {
    listViewPort = '#listViewPort';
    listView = '#listView';
    subscriberDetails = '#subscriberDetails';
    searchDiv = '#searchDiv';
    spinnerPositionForBalloons = '#spinnerPositionForBalloons';
    superInitialize = GenericView.prototype.initialize;

    @debounce(200)
    scrollFunction(self) {
        const scrollTop = $(self.listViewPort).scrollTop();
        // This check means that we are scrolling downwards.
        if (scrollTop > self.lastScrollTop) {
            const lvPortHeight = $(self.listViewPort).height();
            const lvHeight = $(self.listView).height();
            // This check means we are near the bottom of the scroll bar.
            if (scrollTop + lvPortHeight > lvHeight - 5) {
                $(self.spinnerPositionForBalloons).html(Handlebars.partials.spinner);
                self.getNextPage();
            }
        }
        self.lastScrollTop = scrollTop;
    }

    @debounce(800)
    @on('keyup .filter_message')
    searchByFilter() {
        const self = this;

        self.collection.filters = false;
        self.collection.url = `${self.options.collectionUrl}?`;
        self.inSearch = false;
        $('#messages-container').find('.searchbox').each(function (index, elem) {
            if ($(elem).hasClass('filter_message')) {
                const text = $(elem).val().toLowerCase();

                self.collection.url += `filter_message=${text}`;
                self.collection.filters = !(self.collection.filters || (!text || 0 === text.length));
                self.inSearch = true;
            }
        });

        $(self.spinnerPositionForBalloons).html(Handlebars.partials.spinner);
        self.getFirstPage(true);
    }

    getNextPage() {
        this.collection.getNextPage()
            .then(() => this.trigger(`pageFetchedForSubscription${this.subscriptionId}`))
            .catch(response => console.error(response));
    }

    getFirstPage(fromSearch) {
        this.collection.getFirstPage()
            .then(() => this.trigger(`pageFetchedForSubscription${this.subscriptionId}`, fromSearch))
            .catch(response => console.error(response));
    }

    pageFetched(fromSearch) {
        const self = this;
        $(self.spinnerPositionForBalloons).empty();

        // If we are from search we want to first empty the listview.
        if (fromSearch)
            $(self.listView).empty();
        this.addAll(this.collection.models);
        const listViewPortHeight = $(self.listViewPort).height();
        const listViewHeight = $(self.listView).height();

        // This check means      1. that the items fetched and rendered produce a smaller height than
        //                          the viewport's height so we want to fetch more in order to be able
        //                          to create a scrollbar otherwise it would stop vertical pagination.
        //                       2. that if we trigger fetch for more items and the previous listview
        //                          height is equal to the current one that means we fetched nothing
        //                          so we avoid infinite loop.
        //                       3. we also check for previous listView height being `0`, otherwise, in case
        //                          there is only one page, it will make two calls:
        //                          a) `MessagesWithFilters` for page=0
        //                          b) `MessagesWithFilters` for page=1
        //                       4. we also check the height and the count of the elements,
        //                          in case there are many user actions (redemptions/optins etc),
        //                          that lead on messages being hidden and the scroll functionality not working
        //                       5. in case there are many custom fields, we add a check for existing `nextPage`
        //                          or else the `self.getNextPage()` will enter a non-ending loop

        const hasNextPage = self.collection.count / self.collection.state.pageSize > self.collection.state.currentPage + 1;

        if (self.previousListViewHeight <= listViewHeight &&
            listViewHeight <= listViewPortHeight         &&
            ((self.previousListViewHeight == 0 &&
              self.collection.count > self.collection.state.pageSize) ||
              self.previousListViewHeight > 0)          &&
              hasNextPage) {

            $(self.spinnerPositionForBalloons).html(Handlebars.partials.spinner);
            self.previousListViewHeight = listViewHeight;
            self.getNextPage();
        }
    }

    constructor(options) {
        super(options);
        this.options = options;
        this.subscriptionId = this.options.subscription.get("subscriptionId");
        this.inSearch = false;
        this.totalLength = 0;
        this.collection = new PaginatedCollection();
        this.collection.url = this.options.collectionUrl;
        this.collection.filters = false;
        this.previousListViewHeight = 0;
        this.on(`pageFetchedForSubscription${this.subscriptionId}`, fromSearch => this.pageFetched(fromSearch));
        $(this.spinnerPositionForBalloons).html(Handlebars.partials.spinner);
        this.getFirstPage();
        this.lastScrollTop = 0;
        const subscriberDetailsHeight = $(this.subscriberDetails).height();
        const searchDivHeight = $(this.searchDiv).height();
        $(this.listViewPort).css('max-height', subscriberDetailsHeight - searchDivHeight);
        $(this.listViewPort).on('scroll', () => {
            this.scrollFunction(this);
        });
    }

    render() {
        const self = this;
        if (!this.collection.filters) {
            $('.messages-count').html(this.collection.count);
            $('.filter-messages-count').html("");
        } else {
            $('.filter-messages-count').html(i18n.t("outOf", {n: this.collection.count, m: ''}));
        }

        const deletionBtn = $(".delete");
        const deletionMessage = i18n.t("subscriber.cannotdelete");

        $('#sms-mail-count').text(`${self.collection.extras.smsCnt} SMS, ${self.collection.extras.emailCnt} Email`);

        if (self.collection.extras.isReferenced) {
            if (deletionBtn) {
                deletionBtn.attr({"disabled": true, "title": deletionMessage});
                deletionBtn.unbind("click");
                deletionBtn.css("cursor", "not-allowed");
            } else {
                deletionBtn.attr({"disabled": false, "title": false});
            }
        }

        if (!this.inSearch) {
            this.totalLength = this.collection.count;
        }
        if (!this.totalLength) {
            self.hideMessagesToContactSearchBox();
            self.showNoMessagesToContactMessage();

        } else {
            self.hideNoMessagesToContactMessage();
            self.showMessagesToContactSearchBox();
        }

        // Replace view's pagination
        // $('#pagination').html(this.pagination.$el);
    }

    showNoMessagesToContactMessage() {
        $("#nomsgstocontactsearch").show();
    }

    hideNoMessagesToContactMessage() {
        $("#nomsgstocontactsearch").hide();
    }

    showMessagesToContactSearchBox() {
        $("#msgstocontactsearchbox").show();
    }

    hideMessagesToContactSearchBox() {
        $("#msgstocontactsearchbox").hide();
    }

    addAll(models) {
        const self = this;
        _.each(models, (item) => self.addOne(item, self));
        self.render();
    }

    addOne(item, self) {
        item.set("subscription", self.options.subscription);
        const view = new MessageRowView({model: item});
        $(self.listView).append(view.render().el);
    }

    @on('click .showImage')
    showImage(ev) {
        const self = this;
        const $2 = $(ev.currentTarget);
        const contentId = $2.data("content-id");
        const fileName = $2.data("file-name");
        $.Dialog({
            overlay: true,
            shadow: true,
            icon: '<span class="icon icon-file" style="color: white"></span>',
            title: fileName,
            draggable: true,
            height: 'auto',
            position: ['center', 'center'],
            content: '',
            padding: 0,
            onShow() {
                self.ContentUsageCollection = new ContentUsageCollection();
                self.ContentUsageCollection.url = `/CampaignCloud/Report/contentUsageStatistics/${contentId}`;
                self.ContentUsageCollection.getFirstPage();
                self.renderContentUsageCollection(contentId);
                console.info("Fetching content statistics");
            }
        });
    }

    renderContentUsageCollection(id) {
        const self = this;
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Content/LoadFileContent/${id}`,
            type: 'get',
            contentType: 'application/json',
            dataType: 'json'
        }).done(function (response) {
            if (response) {
                const fileType = response.fileType;
                const fileSubType = response.fileSubType;
                const filePath = response.filePath;
                const filename = response.filename;
                const fileLength = response.fileLength;
                const uploadedOn = response.created;
                const inPromoConfiguration = self.ContentUsageCollection.inPromoConfiguration;
                const inVoucherConfiguration = self.ContentUsageCollection.inVoucherConfiguration;
                const inContentManagement = self.ContentUsageCollection.inContentManagement;
                const hasStatisticsToShow = self.ContentUsageCollection.hasStatisticsToShow;
                const totalSent = self.ContentUsageCollection.totalSent;
                const totalViewed = self.ContentUsageCollection.totalViewed;
                const canDelete = false;
                const contentUsages = self.ContentUsageCollection.models;
                const contentId = response.contentId;
                self.collectionPreviewTemplate = Handlebars.compile(PreviewTemplate)({
                    "contentId": contentId,
                    "fileType": fileType,
                    "filePath": filePath,
                    "filename": filename,
                    "fileLength": fileLength,
                    "fileSubType": fileSubType,
                    "inPromoConfiguration": inPromoConfiguration,
                    "inVoucherConfiguration": inVoucherConfiguration,
                    "hasStatisticsToShow": hasStatisticsToShow,
                    "totalSent": totalSent,
                    "totalViewed": totalViewed,
                    "inContentManagement": inContentManagement,
                    "contentUsages": contentUsages,
                    "canDelete": canDelete,
                    "uploadedOn": uploadedOn
                });
                const content = $($.Metro.METRO_DIALOG.children(".content"));
                content.html(self.collectionPreviewTemplate);
                const $window = $('.window.shadow');
                $window.css("height", "auto");
                $window.css("top", "15px");
                self.$('[data-i18n]').i18n();
                if (inContentManagement && self.ContentUsageCollection.hasStatisticsToShow) {
                    if (self.paginationReport) {
                        self.paginationReport.remove();
                    }
                    // Render collection the 1st time
                    self.paginationReport = new PaginatedView({collection: self.ContentUsageCollection});
                    self.paginationReport.render();
                    // Replace view's pagination
                    $('#pagination-report').html(self.paginationReport.$el);
                }
            } else {
                console.error("Error fetching file with id = " + id);
            }
        }).fail(function (response) {
            console.error(response);
        });
    }
}

export default MessagesView;